import { Chart, ChartOption } from '@/components/Base/Chart.tsx';
import { formatLargeNumber } from '@/utils/formatLargNumber';
import { Box } from '@mui/material';
import { useEffect, useState } from 'react';

const ScoreInadimplenciaChartTurmaOcupacao = ({ color, title, labelColor, data }) => {
  const [drawerWidth, setDrawerWidth] = useState('LT');

  const months = data?.valor_score_meses?.map((item) => item.nome.charAt(0).toUpperCase() + item.nome.slice(1));
  const receivedValues = data?.valor_score_meses?.map((item) => item.valor);
  const delinquentPercentages = data?.valor_score_meses?.map((item) => item.valor_secundario);
  const series = [
    {
      data: receivedValues,
      type: 'bar',
      stack: 'a',
      name: 'LTV',
      itemStyle: {
        borderRadius: [10, 10, 10, 10],
        color: color,
      },
    },
    {
      name: drawerWidth,
      type: 'line',
      yAxisIndex: 1,
      data: delinquentPercentages,
      smooth: true,
      lineStyle: {
        color: '#E04A4C',
        width: 4,
      },
      symbol: 'circle',
      symbolSize: 20, 
      itemStyle: {
        color: '#7C0D21', 
      },
      label: {
        show: true,
        formatter: (params) => `${delinquentPercentages[params.dataIndex]} anos`,
        borderRadius: 50,
        fontSize: '11px',
        color: '#7C0D21',
        align: 'center',
        fontWeight: 'bold',
        position: 'bottom',
      },
    },
  ];

  const option = {
    title: {
      text: title,
      textStyle: {
        fontSize: '12px',
      },
    },
    legend: {
      data: [drawerWidth, 'LTV'],
      right: '0',
    },
    tooltip: {
      trigger: 'axis',
      formatter: (params) => {
        let tooltipContent = '';
        params.forEach((param) => {
          if (param.seriesType === 'bar') {
            tooltipContent += `
              <div> Ano: ${param.name} </div>
              <div> LTV: ${formatLargeNumber(param.value)} </div>
            `;
          } else if (param.seriesType === 'line') {
            tooltipContent += `
              <div> LT: ${param.value} anos</div>
            `;
          }
        });
        return tooltipContent;
      },
    },
    yAxis: [
      {
        type: 'value',
        name: '',
        position: 'left',
      },
      {
        type: 'value',
        name: '',
        position: 'right',
        axisLabel: {
          formatter: '',
        },
      },
    ],
    xAxis: {
      type: 'category',
      data: months,
    },
    series,
  } as ChartOption;

  return (
    <Box sx={{ boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)', padding: '20px 10px 0 10px' }} height={'400px'}>
      <Chart option={option} />
    </Box>
  );
};

export default ScoreInadimplenciaChartTurmaOcupacao;
